import { createIcon } from './utils/createIcon.js';

export default createIcon({
  paths: [
    'M18.5 18.001h-17c-.827 0-1.5-.673-1.5-1.5v-10.5c0-.352.119-.856.276-1.171l.553-1.106C1.035 3.311 1.539 3 2 3h7c.461 0 .964.311 1.171.724l.553 1.106c.038.077.191.171.276.171h7.5c.827 0 1.5.673 1.5 1.5v10c0 .827-.673 1.5-1.5 1.5zM2 4.001c-.086 0-.238.094-.276.171l-.553 1.106c-.088.176-.171.527-.171.724v10.5c0 .276.224.5.5.5h17c.276 0 .5-.224.5-.5v-10c0-.276-.224-.5-.5-.5H11c-.461 0-.965-.311-1.171-.724l-.553-1.106c-.038-.077-.191-.171-.276-.171H2z',
  ],
  height: 20,
  width: 20,
});
